/* unplugin-vue-components disabled */import { render } from "./VerticalBarChart.vue?vue&type=template&id=1cd27420&scoped=true"
import script from "./VerticalBarChart.vue?vue&type=script&lang=js"
export * from "./VerticalBarChart.vue?vue&type=script&lang=js"

import "./VerticalBarChart.vue?vue&type=style&index=0&id=1cd27420&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd27420"]])

export default __exports__